// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__25tYn","content":"styles_content__2T894","checkbox":"styles_checkbox__23yHg","checkboxLabel":"styles_checkboxLabel__2GPZy"};